var _defs, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterDriveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.6 27.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0f8038;\n      }\n\n      .st1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .st2 {\n        fill: #1767d1;\n      }\n\n      .st3 {\n        fill: #4185f3;\n      }\n\n      .st4 {\n        fill: #30a753;\n      }\n\n      .st5 {\n        fill: #f9bc00;\n      }\n\n      .st6 {\n        fill: #e94235;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "22 5.5 2 5.5 10 15 10 21.5 14 23.5 14 15 22 5.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.8,17.2h-5.7l-2.4,4.3c.3.1.6.2.8.2,2.2,0,6.8,0,9.1,0s.5,0,.6-.2l-2.4-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.7,21.5l2.4-4.3h-4.9c0,.3.1.6.3.9.5.9,1.2,2.2,1.7,3,.1.2.6.4.5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.8,17.2l2.4,4.3c.3-.2.6-.5.7-.8.4-.7,1-1.8,1.5-2.5.2-.3.3-.7.3-.9h-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.1,17.2l2.8-4.9-2.5-4.2c-.3.2-.5.4-.6.6-1.1,1.9-3.3,5.9-4.5,7.9-.1.2-.2.4-.2.7h4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.8,17.2l-2.8-4.9,2.5-4.2c.3.2.6.4.7.6,1.1,1.9,3.3,5.9,4.5,7.9.1.2.2.4.1.7h-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,8.1l2.5,4.2,2.5-4.2c-.3-.1-.6-.2-1-.2-1,0-2.6,0-3.4,0-.2,0-.6.3-.6.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDriveDark);
export default __webpack_public_path__ + "static/media/filter-drive-dark.d6b99fc621da2dfd3f5cf3904b81732b.svg";
export { ForwardRef as ReactComponent };